import React from 'react';

const Podcast = () => (
  <section id="podcast" className="g-pt-75 g-pb-45 g-bg-gray-light-v4">
    <div className="container">
      <header className="text-center g-width-60x--md mx-auto g-mb-20">
        <div className="u-heading-v2-3--bottom g-brd-primary g-mb-10">
          <h2 className="h4 u-heading-v2__title g-color-gray-dark-v2 g-font-weight-600 text-uppercase g-mt-minus-10 g-mb-5">
            Podcast
          </h2>
        </div>
        <p className="g-font-size-16 g-mb-0">
          Bishop K.J. Brown Podcast
        </p>
      </header>

      <div className="row justify-content-center g-mb-0">
        <div className="col-md-12 col-lg-12 g-mb-30">
          <iframe
            src="https://widget.spreaker.com/player?show_id=4234579&theme=dark&autoplay=false&playlist=show"
            width="100%"
            height="400"
            frameBorder="0"
            title="Bishop K.J. Brown Podcast Player"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  </section>
);

export default Podcast;

